import activityStyles from '../../../../components/_shared/ActivityCard.module.scss';
import { arrowTopRightWhite, screenerLogo } from '../../../../../../assets/hostedassets';
import { DATE_FORMATS, formatDateByFormat } from '../../../../../../utils/dateUtils';

interface ScreenerData {
    ticker: string;
    stockPrice: string;
    priceChange: string;
    priceChangeDirection: 'up' | 'down';
    screenerUrl: string;
}

interface ScreenerCardProps {
    screenerData: ScreenerData;
    generatedAt?: string;
}

function ScreenerCard({ screenerData, generatedAt }: ScreenerCardProps) {
    const { stockPrice, priceChange, priceChangeDirection, screenerUrl, ticker } = screenerData;
    const isUp = priceChangeDirection === 'up';
    const asOfDate = generatedAt ? formatDateByFormat(generatedAt, DATE_FORMATS.DATE_FORMAT_DD_MMM_YYYY) : '';

    return (
        <div className={activityStyles.ScreenerSummaryCard}>
            <div className={activityStyles.Left}>
                <img src={screenerLogo} alt="Screener.in" className={activityStyles.ScreenerLogo} />
                <div className={activityStyles.ScreenerPriceRow}>
                    <span className={activityStyles.ScreenerLabel}>STOCK PRICE</span>
                    <span className={activityStyles.ScreenerPrice}>₹{stockPrice}</span>
                    <span className={isUp ? activityStyles.ScreenerBadgeUp : activityStyles.ScreenerBadgeDown}>
                        {isUp ? '+' : '-'}
                        {priceChange}
                    </span>
                </div>
                {asOfDate && <span className={activityStyles.ScreenerAsOf}>as of {asOfDate}</span>}
            </div>
            <a
                href={screenerUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={activityStyles.Right}
                aria-label={`View ${ticker} on Screener.in`}
            >
                <div className={activityStyles.ArrowCircle}>
                    <img src={arrowTopRightWhite} alt="" className={activityStyles.ArrowIcon} />
                </div>
            </a>
        </div>
    );
}

export default ScreenerCard;
